/**
 * Whether this `documents[]` entry links the leaf to a persisted markdown guide.
 * `documentPath` may be absent, null, or whitespace-only when the leaf intentionally has no guide;
 * in that case no `documents/{nodeId}.md` object is required in storage.
 */
export function documentEntryHasLinkedGuide(doc) {
    const path = doc.documentPath;
    return typeof path === 'string' && path.trim() !== '';
}
